<template>
<div>
  <form @submit.prevent="fetchDomainDetails">
    <span>
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <b-autocomplete
          :data="domainSuggestions"
          @typing="onSearch"
          @select="fetchDomainDetails"
        >
          <template #default="props">
            {{props.option.name}}
          </template>
        </b-autocomplete>
      </div>
    </span>
  </form>

  <form v-if="domainDetails != null" @submit.prevent="create()">
    <span>
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <!--<text-input v-model="domainCreate.name" :error="domainCreate.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Domain Name" /> -->
          <table class="table-auto mr-4">
            <td>{{domainDetails.domain}}</td>
            <td>{{domainDetails.available}}</td>
            <td>{{domainDetails.registrationPrice}}</td>
          </table>
        <loading-button :loading="domainCreate.processing" class="btn-indigo">Save Domain</loading-button>
      </div>
    </span>
  </form>
</div>
</template>

<script>
//import { Head, Link } from '@inertiajs/vue2'
import axios from 'axios'
import debounce from 'lodash/debounce'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
export default {
  components: {
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    sectorTarget: Object,
  },
  remember: ['domainCreate','domainSearch'],
  data() {
    return {
      isFetchingDomain: false,
      customDomain: '',
      domainDetails: null,
      //domainSearch: this.$inertia.form({
      //  name: null,
      //}),
      domainCreate: this.$inertia.form({
        name: null,
        available: null,
        sector_target_id: null,
      }),
    }
  },
  computed: {
    domainData() {
      return {
        sector_target_id: this.sectorTarget.id,
        name: this.domainDetails.domain,
        available: this.domainDetails.available
      }
    },
    domainSuggestions() {
      let city = this.sectorTarget.market.city.replace(/[^a-zA-Z0-9-_]/g, '');
      let state = this.sectorTarget.market.state.replace(/[^a-zA-Z0-9-_]/g, '');
      let verticalName = this.sectorTarget.vertical.name.replace(/[^a-zA-Z0-9-_]/g, '');
      let currentDomains = this.sectorTarget.domains.map(function (domain){
        return domain.name;
      });
      return [
        {name: encodeURIComponent(city+state+verticalName+".com")},
        {name: verticalName+city+state+".com"},
        {name: city+verticalName+".com"},
        {name: verticalName+city+".com"},
        {name: this.customDomain.toString()}
      ].filter(function(domain){
        return !currentDomains.includes(domain.name.toLowerCase());
      });
    }
  },
  methods: {

    create() {
      this.domainCreate.transform((data) =>({
        ...data,
        ...this.domainData
      })).post('/domains');
      this.$emit('onCreate',this.domainData);
    },

    onSearch(query) {
      this.customDomain = query;
    },

    fetchDomainDetails: debounce(async function(query) {
      let name = query.name
      //let name = this.domainSearch.name
      if (!name.length) {
        this.domainDetails = null
        return
      }
      this.isFetchingDomain = true
      let r = await axios.get('/dns/details?domain='+name);
      this.domainDetails = r.data;

      this.isFetchingDomain = false;
    }, 250),
    domainErrors() {
      if(!this.domainCreate.errors){return null;}
      return Object.values(this.domainCreate.errors).join(" ");
    }
  },
  emits: ['onCreate']
}
</script>
